export enum QuotationResponseType {
  mustLogin,
  activateEmail,
  Success,
  UnknownError,
  invalidQuote,
  bchQualify,
}

export enum ModalType {
  registerLoginShortlist,
  registerLoginStartOrder,
  verifyEmail,
  quoteSaved,
  invalidQuote,
  bchQualify,
  nonQuotable,
}

export enum OptionType {
  paint,
  trim,
  hood,
  option,
}

export enum PricingType {
  Personal = 'Personal',
  Business = 'Business',
}
